import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowHeadLeft = props => (
  <SvgIcon {...props} viewBox="0 0 7.4000001 12">
    <polygon points="7.4 10.6 2.8 6 7.4 1.4 6 0 0 6 6 12" />
  </SvgIcon>
);

export default IconArrowHeadLeft;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowHeadLeft.js